module.exports = __webpack_public_path__ + "img/bell-icon.svg";